/**
 * DetailCrewItemContainer component.
 */
import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

/**
 * Styled detail crew item container.
 */
const DetailCrewItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-bottom: ${10 * Screen.widthRatio}px;
`;

export default DetailCrewItemContainer;
